
import React from 'react';
import { RELEASE_LABEL } from '../../../config/release';
import { useSystemFlag } from '../../../config/useSystemFlags';
import { getAppMarket } from '../../../services/MarketService';

const Footer = () => {
    const releaseVisible = useSystemFlag('releaseFooter');
    // F-308: the UK tagline and the UK/EU DPA are not Texas copy.
    const isTexas = getAppMarket() === 'texas';
    return (
        <footer className="bg-gray-900 text-white py-12 mt-16">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="grid md:grid-cols-4 gap-8 mb-8">
                    <div>
                        <div className="flex items-center space-x-2 mb-4">
                            <div className="w-8 h-8 bg-green-600 rounded-lg flex items-center justify-center">
                                <i className="fas fa-home text-white text-sm"></i>
                            </div>
                            <span className="text-xl font-bold">Landlord Pro</span>
                        </div>
                        <p className="text-gray-400 text-sm">{isTexas ? 'Complete property compliance for Texas landlords.' : 'Complete property compliance for UK landlords.'}</p>
                    </div>

                    <div>
                        <h4 className="font-semibold mb-4 text-sm">Product</h4>
                        <ul className="space-y-2 text-sm text-gray-400">
                            <li><a href="#" className="hover:text-white transition-colors">Features</a></li>
                            <li><a href="#" className="hover:text-white transition-colors">Pricing</a></li>
                            <li><a href="/lia.html" target="_blank" rel="noopener noreferrer" title="Legitimate Interests Assessment (LIA)" aria-label="Legitimate Interests Assessment (LIA)" className="hover:text-white transition-colors">LIA</a></li>
                        </ul>
                    </div>

                    <div>
                        <h4 className="font-semibold mb-4 text-sm">Support</h4>
                        <ul className="space-y-2 text-sm text-gray-400">
                            <li><a href="#" className="hover:text-white transition-colors">Help Center</a></li>
                            <li><a href="#" className="hover:text-white transition-colors">Documentation</a></li>
                            <li><a href="#" className="hover:text-white transition-colors">Contact</a></li>
                        </ul>
                    </div>

                    <div>
                        <h4 className="font-semibold mb-4 text-sm">Legal</h4>
                        <ul className="space-y-2 text-sm text-gray-400">
                            <li><a href="/privacy-policy.html" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">Privacy Policy</a></li>
                            {!isTexas && <li><a href="/dpa-template.html" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">DPA Template</a></li>}
                            <li><a href="/data-exit-policy.html" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">Data Exit Policy</a></li>
                            <li><a href="/security" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">Security</a></li>
                            <li><a href="/terms-of-service.html" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">Terms of Service</a></li>
                            <li><a href="/refund-policy.html" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">Refund & Cancellation</a></li>
                            <li><a href="/lia.html" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">LIA</a></li>
                        </ul>
                    </div>
                </div>

                <div className="border-t border-gray-800 pt-8 text-center space-y-1">
                    <p className="text-sm text-gray-400">&copy; {new Date().getFullYear()} Landlord Pro. All rights reserved.</p>
                    {releaseVisible && <p className="text-xs text-gray-500">{RELEASE_LABEL}</p>}
                </div>
            </div>
        </footer>
    );
};

export default Footer;
